import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { api } from '../api';
import { JobsDTO } from '../job-search/job-results.dto';
import {HttpClientModule} from '@angular/common/http';
import {  NgZone } from '@angular/core';
import { HttpClient, HttpEventType, HttpRequest } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

@Injectable()
export class ProfileService {
  indeedAccessCode: string;

  response = {};
  JobAlertsData;
  profileData;
  filteredJobAlertData;
  JobAlertData;
  public resumeType: any;
  constructor(
    private http: HttpClient,
    private ngzone: NgZone) {
   }

  getAppliedJobs() {
    return this.http.get(api.candidate.APPLIED_JOB)
      .catch(this.handleError);
  }

  getFavoriteJobs() {
    return this.http.get(api.candidate.FAVROITE_JOB)
      .catch(this.handleError);
  }

  getMatchedJobs(searchRequest) {
    if (searchRequest === null || searchRequest === '') {
      searchRequest = {
        'SearchText': '*', 'StartRow': 0, 'PageCount': 10, 'Contexts': ['publicjob'],
        'SortFilters': [{ 'SortField': 'score', 'SortDirection': 'desc' }]
      };
    }
    return this.http.post<JobsDTO>(api.candidate.MATCHED_JOBS, searchRequest)
      .map(res => res.searchResults.bins[0])
      .catch(this.handleError);
  }

  getSortFields() {
    const httpParams: HttpParams = new HttpParams()
      .set('context', 'publicjob');
    return this.http.get(api.jobsearch.GET_SORTABLE_FIELDS, { params: httpParams })
      .catch(this.handleError);
  }

  saveFavoriteJob(requisitionId: number) {
    const requestObj = { 'requisitionId': requisitionId };
    return this.http.post(api.candidate.SAVE_FAVORITE_JOB, requestObj)
      .catch(this.handleError);
  }

  getProfileData() {
      return this.http.get(api.candidate.GET_PROFILE_DATA)
        .share()
        .catch(this.handleError);
  }

  updateProfileData() {
    this.profileData = null;
    this.getProfileData();
  }

  setProfileData(data) {
    this.profileData = data;
  }

  getMiniProfileData() {
    return this.profileData;
  }

  applyJob(requisitionId: number, eQuestSource?: string, resumeId?: number) {
    const requestObj = { 'requisitionId': requisitionId, 'eQuestSource': eQuestSource, 'resumeFK' : resumeId };
    return this.http.post(api.candidate.APPLY_JOB, requestObj)
      .catch(this.handleError);
  }

  getCandidateProfileData() {
    return this.http.get(api.candidate.GET_CANDIDATE_PROFILE_DETAILS)
      .catch(this.handleError);
  }

  getCandidateEditFormConfiguration() {
    return this.http.get(api.candidate.CANDIDATE_EDIT_FORM_CONFIGURATION)
      .catch(this.handleError);
  }

  getCandidateCreateFormConfiguration() {
    return this.http.get(api.candidate.CANDIDATE_CREATE_FORM_CONFIGURATION)
      .catch(this.handleError);
  }

  getStatesByCountry(countryId) {
    const httpParams: HttpParams = new HttpParams()
      .set('countryId', countryId);
    return this.http.get(api.candidate.GET_STATES_BY_COUNTRY, { params: httpParams })
      .catch(this.handleError);
  }

  uploadFile(formData) {
    return this.http.post(api.candidate.FILE_UPLOAD, formData)
      .catch(this.handleError);
  }

  upload(fileData: any, progressCallback: (param) => any, successCallback: (param) => any, errorCallback: (param) => any) {
      const req = new HttpRequest('POST', api.candidate.FILE_UPLOAD, fileData, {
        reportProgress: true,
      });
      return this.http.request(req).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.ngzone.run(() => {
            progressCallback(Math.round(100 * event.loaded / event.total));
          });
        }
        if (event.type === HttpEventType.Response) {
          this.ngzone.run(() => {
            successCallback(event.body);
          });
        }
      }, error => {
        errorCallback(error);
      });
    }

  downloadFile(fileId) {
    const httpParams: HttpParams = new HttpParams()
      .set('fileId', fileId);
    return this.http.get(api.candidate.FILE_DOWNLOAD, { params: httpParams, responseType: 'blob' });
  }

  downloadPersonalData() {
    return this.http.get(api.candidate.DOWNLOAD_PERSONAL_DATA, { responseType: 'blob' });
  }

  saveCandidateProfile(profileJson: string, attachments: any, preferences: any) {
    const postData = {
      'personJson':  profileJson ,
      'attachments': attachments,
      'preferences': preferences
    };
    return this.http.post(api.candidate.SAVE_CANDIDATE_PROFILE, postData)
      .catch(this.handleError);
  }

  setIndeedAccessCode(accessCode: string) {
    this.indeedAccessCode = accessCode;
  }

  getIndeedAccessCode() {
    return this.indeedAccessCode;
  }

  private handleError(error: Response | any) {
    return Observable.throw(error);
  }
  deleteAccount() {
     return this.http.post(api.candidate.DELETE_ACCOUNT, {} )
      .catch(this.handleError);
  }

  setResumeType(resumetype) {
    this.resumeType = resumetype;
  }

  getResumeType() {
    return this.resumeType;
  }

  getOfferDetails(offerId) {
      const httpParams: HttpParams = new HttpParams()
        .set('offerId', offerId);
      return this.http.get(api.offer.OFFER_DETAILS, { params: httpParams })
        .catch(this.handleError);
  }
}




// WEBPACK FOOTER //
// ../UI/src/app/shared/profile/profile.service.ts